import { Dialog } from '@cimplico/components';
import plural from '../../utilities/plural';

type DeleteJournalsConfirmDialogProps = {
    journalIds: string[];
    onClose: () => void;
    onDelete: () => void;
};

function DeleteJournalsConfirmDialog({ journalIds, onClose, onDelete }: DeleteJournalsConfirmDialogProps): JSX.Element {
    return (
        <Dialog
            isOpen={true}
            description={`Do you want to delete ${journalIds.length} draft ${plural(
                journalIds.length,
                'journal',
                'journals'
            )}?  Deleted journals cannot be recovered.`}
            primaryAction="Delete"
            secondaryAction="Cancel"
            title={`Delete Draft ${plural(journalIds.length, 'Journal', 'Journals')}`}
            type="error"
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={onDelete}
        />
    );
}
export default DeleteJournalsConfirmDialog;
